import { autoinject, computedFrom, transient, useView } from "aurelia-framework";
import { ChildComponent } from "../../../child-component";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { IncidentClientModel } from "../../../../../../models/incidents/incident.models";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";
import { IncidentStatusEnum } from "../../../../../../models/vetting/vetting.models";
import { Reflection } from "../../../../../../utilities/reflection";

@autoinject
@transient()
@useView('views/pages/modules/incident/tabs/details/incident-details.html')
export class IncidentDetails extends ChildComponent<IncidentClientModel>
{
    constructor(notificationsService: NotificationClientService, i18N: I18N, private userClaimsService: UserClaimsService) {
        super(notificationsService, i18N);
    }

    @computedFrom(Reflection.getPropertyPath<IncidentDetails>(z => z.item),
    Reflection.getPropertyPath<IncidentDetails>(z => z.item.incidentStatusId))
    get closed() {
        return this.item &&
            this.item.incidentStatusId == IncidentStatusEnum.Closed;
    }

    @computedFrom(Reflection.getPropertyPath<IncidentDetails>(z => z.closed),
    Reflection.getPropertyPath<IncidentDetails>(z => z.userClaimsService))
    get canEditIncidentDetails()
    {
        return this.closed ? this.userClaimsService.hasPermission(Claims.CanEditClosedIncidentDetails) || this.userClaimsService.hasPermission(Claims.CanViewIncidentEdits) : 
            this.userClaimsService.hasPermission(Claims.CanEditIncidentDetails) || this.userClaimsService.hasPermission(Claims.CanViewIncidentEdits);
    }
    
    public getNullableBoolText(value: boolean): string
    {
        if(value == true) return 'Yes';
        if(value == false) return 'No';

        return null;
    }
}